export { default } from './StatusesDescTable';



// WEBPACK FOOTER //
// ./src/components/Rating/StatusesDescTable/index.js